import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "prompt", "saveToggle", "saveNameField", "saveName"]

  connect() {
    this.appliedPrompt = null
    this.applySelectedPrompt({ preserveExisting: true })
    this.toggleSavePrompt()
  }

  select() {
    this.applySelectedPrompt({ preserveExisting: false })
  }

  toggleSavePrompt() {
    if (!this.hasSaveToggleTarget || !this.hasSaveNameFieldTarget || !this.hasSaveNameTarget) return

    const saveEnabled = this.saveToggleTarget.checked
    this.saveNameFieldTarget.classList.toggle("hidden", !saveEnabled)
    this.saveNameTarget.disabled = !saveEnabled

    if (saveEnabled) {
      this.saveNameTarget.focus()
    } else {
      this.saveNameTarget.value = ""
    }
  }

  applySelectedPrompt({ preserveExisting }) {
    if (!this.hasSelectTarget || !this.hasPromptTarget) return

    const option = this.selectTarget.selectedOptions[0]
    const prompt = option?.dataset.prompt || ""

    if (!this.selectTarget.value) {
      if (this.promptTarget.value === this.appliedPrompt) {
        this.promptTarget.value = ""
      }
      this.appliedPrompt = null
      return
    }

    if (preserveExisting && this.promptTarget.value.trim()) return

    this.promptTarget.value = prompt
    this.appliedPrompt = prompt
    this.promptTarget.focus()
  }
}
